import { Component, Inject, OnInit, AfterViewInit, OnDestroy } from "@angular/core";
import { DOCUMENT, NgIf, AsyncPipe } from "@angular/common";
import { NGXLogger } from "ngx-logger";
import { environment } from "../../../environments/environment";
import { DialogService } from "primeng/dynamicdialog";
import { MessageService } from "primeng/api";
import { AuthService } from "@auth0/auth0-angular";
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { NotLoggedHomeComponent } from "../../components/home/not_logged.component";
import { ToastModule } from 'primeng/toast';
import { UserService } from "../../services/user.service";
import { DashboardComponent } from "../../components/dashboard/dashboard.component";
import { RichiesteComponent } from "../../pages/richieste/richieste.component";
import { tap } from "rxjs/operators";
import { Subscription } from "rxjs";

@Component({
  selector: "home",
  templateUrl: "./home.component.html",
  styleUrls: ["./home.component.css"],
  providers: [DialogService, MessageService],
  standalone: true,
  imports: [NotLoggedHomeComponent, NgIf, AsyncPipe, ToastModule, DashboardComponent, RichiesteComponent],
})
export class HomeComponent implements OnInit, AfterViewInit, OnDestroy {

  protected isLoadingResults: boolean = true;
  protected isPresidioTIM: boolean = false;
  protected showDashboard: boolean = false;
  private subscription = new Subscription();
  options: any;
  data: any;
  private redirectDone: boolean = false;

  constructor(
    public auth: AuthService,
    private logger: NGXLogger,
    public dialogService: DialogService,
    private messageService: MessageService,
    @Inject(DOCUMENT) private doc: Document,
    private http: HttpClient,
    private userService: UserService,
    private router: Router
  ) {
    this.isLoadingResults = true;
  }

  ngOnInit(): void {
    //this.logger.info("[HOME] INIT");

    // Recupera il token all'avvio della sessione se l'utente è autenticato
    this.auth.isAuthenticated$
      .pipe(
        tap((isAuthenticated: boolean) => {
          if (isAuthenticated) {
            this.auth.getAccessTokenSilently().subscribe(token => {
              if (token) {
               // console.log('Token ottenuto con successo');
                localStorage.setItem("token", token);
              }
            });
          }
        })
      )
      .subscribe();

    // Carica le informazioni dell'utente quando disponibili
    this.auth.user$.subscribe((user: any) => {
      if (user) {
        //this.logger.info("[HOME] USER LOGGED - LOAD USER INFO");
        this.userService.loadAndSetUserInformation(user);
      }
    });

    // Sottoscrizione alle informazioni dell'utente usando il nuovo Observable
    this.subscription.add(
      this.userService.userInfo$.subscribe(userInfo => {
        if (userInfo && userInfo.ruolo) {
          //this.logger.info("[HOME] Informazioni utente aggiornate:", userInfo);

          // Verifica se l'utente è un presidio TIM
          this.isPresidioTIM = userInfo.ruolo === "UMVS";

          // Verifica se l'utente ha uno dei ruoli autorizzati a vedere la dashboard
          const userRole = userInfo.ruolo;
          this.showDashboard = userRole === "SUPERADMIN" || userRole === "ADMIN" || userRole === "UMVS";
          //this.logger.info(`[HOME] Ruolo utente: ${userRole} - Mostra dashboard: ${this.showDashboard}`);

          // Se l'utente è un ENTE_ESECUTORE, reindirizza alla pagina richieste con il parametro ente
          if (userRole === "ENTE_ESECUTORE" && !this.redirectDone) {
            const enteId = localStorage.getItem("enteId");
            if (enteId) {
              //this.logger.info(`[HOME] Reindirizzamento a richieste per ENTE_ESECUTORE: ${enteId}`);
              this.redirectDone = true;
              this.router.navigate(['/richieste'], {
                queryParams: { ente: enteId },
                replaceUrl: true
              });
            }
          }
        }
      })
    );
  }

  ngAfterViewInit() {
    // Implementazione da aggiungere
  }

  ngOnDestroy() {
    // Pulizia delle sottoscrizioni
    this.subscription.unsubscribe();
  }
}
